export interface PossibleTypesResultData {
    possibleTypes: {
        [key: string]: string[];
    };
}
const result: PossibleTypesResultData = {
    possibleTypes: {
        CardTypeUnionModel: ['BasicMarketingCardModel', 'PollCardModel', 'SubscriptionBadgeModel'],
        ActionUnionModel: [
            'CopyToClipboardActionModel',
            'LaunchFlowActionModel',
            'LinkActionModel',
        ],
        Contract: ['Flex', 'Mix'],
        BasicContract: ['Flex', 'Mix'],
        ContractAction: [
            'Buyout',
            'CancelOrderEarly',
            'PrintReturnLabel',
            'ReportDamage',
            'SupportRequest',
        ],
        Period: ['BillingPeriod', 'LastCommittedPeriod'],
        ContractDiscounts: ['InternalDiscount'],
        Discount: ['InternalDiscount'],
        Flows: ['Completion', 'Purchase', 'Replacement', 'Revocation'],
        Operation: ['Completion', 'Purchase', 'Replacement', 'Revocation'],
        CheckProviderReport: ['CompanyVerificationCheck', 'OnfidoCheck'],
        CatalogItem: ['MixDevice', 'FlexDevice'],
        ProductFilter: ['KeywordFilter', 'RangeFilter'],
        ReturnSteps: ['AccessoriesReturnStep', 'ConfirmableReturnStep', 'ReturnStepsOutcome'],
        BasicReturnStep: ['AccessoriesReturnStep', 'ConfirmableReturnStep'],
        CatalogItemVariant: ['MixDevice', 'FlexDevice'],
        ContractGoods: ['MixDevice', 'FlexDevice'],
        PaymentsUnion: ['GroupPayment', 'OrderPayment', 'PurchasePayment', 'SubscriptionPayment'],
        PaymentInterface: [
            'GroupPayment',
            'OrderPayment',
            'PurchasePayment',
            'SubscriptionPayment',
        ],
        DateUnion: ['Date', 'TimeEstimate'],
        OrderUnion: ['MixCartOrder', 'Order'],
        OrderLineItem: ['MixLineItem'],
        LineItemMeta: ['FlexCartLineItemMeta', 'LineItemCatalogMeta', 'ReplacedLineItemMeta'],
        SubscriptionNote: [
            'AttentionNote',
            'EndedNote',
            'NextPaymentNote',
            'PausedNote',
            'ProcessingNote',
        ],
        TextNoteInterface: ['AttentionNote', 'EndedNote', 'PausedNote', 'ProcessingNote'],
        PaymentMethod: ['ByInvoice', 'Card', 'Paypal', 'Sepa'],
        PaymentMethodInterface: ['ByInvoice', 'Card', 'Paypal', 'Sepa'],
        SubscriptionAction: [
            'Buyout',
            'CancelSubscription',
            'ChangePaymentMethod',
            'PaymentMethodPresenter',
            'PrintReturnLabel',
            'ReportDamage',
            'SupportRequest',
            'UpgradeRentalPlan',
        ],
        HistoryMetadata: ['TriggerEventMetadata', 'UserActionMetadata'],
        Node: ['NotificationSendResult', 'Vote'],
        SubscriptionSummary: ['FilterButton', 'Section'],
        SubscriptionListEntry: ['SubscriptionCard', 'SubscriptionStack'],
        VerificationReview: ['FieldReview'],
        PollOptions: ['MoodOptions', 'SingleChoiceOptions', 'ThumbsOptions'],
        PollResults: ['MoodResults', 'SingleChoiceResults', 'ThumbsResults'],
        Goods: ['FlexDevice', 'MixDevice'],
        ContentUnionModel: [
            'BasicMarketingCardContentModel',
            'HintContentModel',
            'PollCardContentModel',
            'SubscriptionBadgeContentModel',
        ],
        AccountType: [
            'AccountBasicModel',
            'AccountManualBookingModel',
            'AccountPayByInvoiceModel',
            'AccountPaymentServiceModel',
        ],
        LoyaltyShopPurchaseMetadataUnion: ['LoyaltyVoucherMetadata'],
        RecurrentType: ['LoopSimulatorModel', 'SimpleSubscriptionModel'],
        FlexDetails: ['Flex', 'SubscriptionDetails'],
        ValidationResult: ['ContractValidationResult'],
        WorkAsset: ['GroverAsset'],
        WorkEmployee: ['GroverEmployee'],
        BundleOrError: ['Bundle', 'BundleError'],
        EnergyLabelOrError: ['EnergyLabel', 'EnergyLabelError'],
        GenericError: [
            'EnergyLabelError',
            'ProductFilterError',
            'ProductsWidgetError',
            'RentalPlanTestError',
        ],
        KeywordFilterOrError: ['KeywordFilter', 'ProductFilterError'],
        RangeFilterOrError: ['ProductFilterError', 'RangeFilter'],
        ProductsWidgetOrError: ['ProductsWidget', 'ProductsWidgetError'],
        RentalPlanTestOrError: ['RentalPlanTest', 'RentalPlanTestError'],
    },
};
export default result;
